import { render, staticRenderFns } from "./team-manage.vue?vue&type=template&id=59a0adc0&scoped=true"
import script from "./team-manage.vue?vue&type=script&lang=ts"
export * from "./team-manage.vue?vue&type=script&lang=ts"
import style0 from "./team-manage.vue?vue&type=style&index=0&id=59a0adc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0adc0",
  null
  
)

export default component.exports